import { listenerMiddleware, RootState } from '../store';
import { api } from '../services/api';

const startSubscriptionListeners = () => {
  // Listener on activeSubscriptionId change to fetch the subscription details
  listenerMiddleware.startListening({
    predicate: (_, currentState, previousState) => {
      // Listen for changes to specific variable

      return (
        (currentState as RootState).subscription.activeSubscriptionId !==
        (previousState as RootState).subscription.activeSubscriptionId
      );
    },
    effect: async (_, listenerApi) => {
      const userId = (listenerApi.getState() as RootState).user.id;
      const subscriptionId = (listenerApi.getState() as RootState).subscription
        .activeSubscriptionId;

      // Fetch subscription details
      if (userId && subscriptionId) {
        listenerApi.dispatch(
          api.endpoints.getSubscriptionDetails.initiate(
            { userId, subscriptionId },
            {
              forceRefetch: true,
            },
          ),
        );
      }
    },
  });

  // listenerMiddleware.startListening({
  //   matcher: api.endpoints.getSubscriptionSummariesByUserId.matchFulfilled,
  //   effect: async (_, { dispatch, getState }) => {
  //     const userId = (getState() as RootState).user.id;
  //     dispatch(api.endpoints.getAllSubscriptionProfits.initiate(userId));
  //   },
  // });

  listenerMiddleware.startListening({
    matcher: api.endpoints.addSubscription.matchFulfilled,
    effect: async ({ payload }, { dispatch, getState }) => {
      const userId = (getState() as RootState).user.id;

      if (payload.subscriptionId) {
        dispatch(
          api.endpoints.getSubscriptionDetails.initiate({
            userId,
            subscriptionId: payload.subscriptionId,
          }),
        );
      }
    },
  });

  listenerMiddleware.startListening({
    matcher: api.endpoints.addBasket.matchFulfilled,
    effect: async ({ payload }, { dispatch, getState }) => {
      const userId = (getState() as RootState).user.id;

      if (payload.subscriptionIds?.length) {
        payload.subscriptionIds.forEach((subscriptionId) => {
          dispatch(
            api.endpoints.getSubscriptionDetails.initiate({
              userId,
              subscriptionId,
            }),
          );
        });
      }
    },
  });
};

export default startSubscriptionListeners;
